// Labeled groups of the primary menu, in render order. Options without a
// `section` render first, unlabeled (Dashboard). Lives outside
// Sidebar.functions.ts because tests mock that module wholesale and would
// lose any extra export.
export const SIDEBAR_PRIMARY_SECTIONS = ['crm', 'tools', 'channels'] as const;
